// extracted by mini-css-extract-plugin
export default {"fallbackIcon":"fallbackIcon---Q6qEg"};